import React, { useState, useEffect } from "react";
// import RequestService from "../../services/RequestService";
import { FaCircle } from "react-icons/fa";
import { parseISO, format } from "date-fns";
import { FaFileExcel } from "react-icons/fa";
import exportToExcelCollectOrders from '../../utils/exportToExcelCollectOrders';
import CompanyService from "../../services/CompanyService"
import GmoService from '../../services/GmoService';
import DepositService from './../../services/DepositService';
import Estados from "../../enums/Estados";
import CollectOrderService from "../../services/CollectOrderService";
import TiposColeta from "../../enums/TiposColeta"
import StatusCollectOrders from "../../enums/StatusCollectOrders";
import { HiOutlineDocumentReport } from 'react-icons/hi';
import CollectOrderDetailsModal from "../modals/Reverse/CollectOrderDetailsModal";


export default function ConsultaGerencialColetas() {

  const statusColor = {
    "NOVO": "#fde047",
    "DEPOSITO": "#d8b4fe",
    "REPASSE PARA ENTREGA": "#bae6fd",
    "ROTA DE ENTREGA": "#38bdf8",
    "ENTREGUE": "#0369a1",
    "FINALIZADO": "#22c55e",
    "GESTAO": "#f87171",
    "CANCELADO": "#cccccc"
  }

  const [collecOrdersList, setCollecOrdersList] = useState({ collectOrders: [], totalPages: 1 });
  const [currentPageCollectOrders, setCurrentPageCollectOrders] = useState();
  const [companiesList, setCompaniesList] = useState([])
  const [gmoList, setGmoList] = useState([]);
  const [depositList, setDepositList] = useState([]);
  const [shouldFetchCollectOrders, setShouldFetchCollectOrders] = useState(false);

  const [collectOrderDetailsModal, setCollectOrderDetailsModal] = useState(false);
  const [collectOrderOnDetailsModal, setCollectOrderOnDetailsModal] = useState();

  //filters
  const [search, setSearch] = useState('');
  const [searchUF, setSearchUF] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  const [searchIdColeta, setSearchIdColeta] = useState('');
  const [searchIdRequest, setSearchIdRequest] = useState('');
  const [searchTipoColeta, setSearchTipoColeta] = useState('');
  
  const [searchTecnico, setSearchTecnico] = useState('');
  const [searchEmpresa, setSearchEmpresa] = useState('');
  const [searchCodSap, setSearchCodSap] = useState('');
  const [searchEquipamento, setSearchEquipamento] = useState('');
  const [searchCodigo, setSearchCodigo] = useState('');
  const [searchSerial, setSearchSerial] = useState('');
  const [searchIdBoleto, setSearchIdBoleto] = useState('');
  const [searchTipoBoleto, setSearchTipoBoleto] = useState('');
  const [searchSite, setSearchSite] = useState('');
  const [searchGmo, setSearchGmo] = useState('');
  const [searchDrsOrigem, setSearchDrsOrigem] = useState('');
  const [searchQtdSolicitadaPrefix, setSearchQtdSolicitadaPrefix] = useState('');
  const [searchQtdSolicitada, setSearchQtdSolicitada] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  // const [status, setStatus] = useState('');


  useEffect(()=>{

    const fetchData = async () =>{
      const result = await CompanyService.getCompanies();
      const gmos = await GmoService.getGmos();
      const deposits = await DepositService.getDeposits();

      setCompaniesList(result.companies)
      setGmoList(gmos.gmos)
      setDepositList(deposits.deposits);
    }
    fetchData();   

  }, []);

  const fetchCollectOrders = async (page = 1) => {

    const params = new URLSearchParams();
    // if (search) params.append('search', search);
    if (searchUF) params.append('uf', searchUF);
    if (searchStatus) params.append('status', searchStatus);
    if (searchIdColeta) params.append('idcoleta', searchIdColeta);
    if (searchIdRequest) params.append('idrequest', searchIdRequest);
    if (searchTipoColeta) params.append('tipocoleta', searchTipoColeta);
    if (searchCodSap) params.append('codsap', searchCodSap);
    if (searchEquipamento) params.append('nomeequipamento', searchEquipamento);
    if (searchCodigo) params.append('codigo', searchCodigo);
    if (searchSerial) params.append('serial', searchSerial);

    if (searchTecnico) params.append('tecnico', searchTecnico);
    if (searchEmpresa) params.append('company', searchEmpresa);
    if (searchIdBoleto) params.append('idboleto', searchIdBoleto);
    if (searchTipoBoleto) params.append('tipoboleto', searchTipoBoleto);
    if (searchSite) params.append('site', searchSite);
    if (searchGmo) params.append('gmo', searchGmo);
    if (searchDrsOrigem) params.append('drsorigem', searchDrsOrigem);
    if (searchQtdSolicitadaPrefix) params.append('qtdsolprefix', searchQtdSolicitadaPrefix);
    if (searchQtdSolicitada) params.append('qtdsol', searchQtdSolicitada);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    // if (status) params.append('status', status);

    const queryString = params.toString();
    const itemsPerPage = 15;
    const collectOrders = await CollectOrderService.getCollectOrders(`?${queryString}`, page, itemsPerPage);
    
    setCollecOrdersList(collectOrders);
    setCurrentPageCollectOrders(page);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= collecOrdersList.totalPages) {
      fetchCollectOrders(newPage);      
    }
  };

  const handleSearch = () => {
    setShouldFetchCollectOrders(true);
    fetchCollectOrders(1);
  };

  useEffect(() => {
    if (shouldFetchCollectOrders) {
      fetchCollectOrders(currentPageCollectOrders);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPageCollectOrders, shouldFetchCollectOrders]);

  const clearFilters = () => {
    setSearch('');
    setSearchUF('');
    setSearchStatus('');
    setStartDate('');
    setEndDate('');
    setSearchIdColeta('');
    setSearchIdRequest('');
    setSearchTipoColeta('')
    setSearchCodSap('')
    setSearchEquipamento('')
    setSearchCodigo('')
    setSearchSerial('')

    setSearchTecnico('');
    setSearchEmpresa('');
    setSearchIdBoleto('')
    setSearchTipoBoleto('')
    setSearchSite('')
    setSearchGmo('')
    setSearchDrsOrigem('')
    setSearchQtdSolicitadaPrefix('')
    setSearchQtdSolicitada('')
    // setStatus('');
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    console.log(e.target.value)
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    console.log(e.target.value)
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    console.log(e.target.value)
  };

  // const handleStatusChange = (e) => {
  //   setStatus(e.target.value);
  //   console.log(e.target.value)
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // Implement your search logic here
  //   console.log('Search:', search);
  //   console.log('Start Date:', startDate);
  //   console.log('End Date:', endDate);
  //   // console.log('Status:', status);
  // };

  const getDescricaoByCod = (cod) => {
    const tipo = TiposColeta.find(item => item.cod === cod);
    return tipo ? tipo.descricao : 'Código não encontrado';
  };

  const handleCollectOrderDetailsModal = async (cOrderId) => {
    setCollectOrderDetailsModal(true)
    setCollectOrderOnDetailsModal(cOrderId)
  };

  const handleExportToExcel = async () => {

    const params = new URLSearchParams();
    if (searchUF) params.append('uf', searchUF);
    if (searchStatus) params.append('status', searchStatus);
    if (searchIdColeta) params.append('idcoleta', searchIdColeta);
    if (searchIdRequest) params.append('idrequest', searchIdRequest);
    if (searchTipoColeta) params.append('tipocoleta', searchTipoColeta);
    if (searchCodSap) params.append('codsap', searchCodSap);
    if (searchEquipamento) params.append('nomeequipamento', searchEquipamento);
    if (searchCodigo) params.append('codigo', searchCodigo);
    if (searchSerial) params.append('serial', searchSerial);
    if (searchTecnico) params.append('tecnico', searchTecnico);
    if (searchEmpresa) params.append('company', searchEmpresa);
    if (searchIdBoleto) params.append('idboleto', searchIdBoleto);
    if (searchTipoBoleto) params.append('tipoboleto', searchTipoBoleto);
    if (searchSite) params.append('site', searchSite);
    if (searchGmo) params.append('gmo', searchGmo);
    if (searchDrsOrigem) params.append('drsorigem', searchDrsOrigem);
    if (searchQtdSolicitadaPrefix) params.append('qtdsolprefix', searchQtdSolicitadaPrefix);
    if (searchQtdSolicitada) params.append('qtdsol', searchQtdSolicitada);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
  
    const queryString = params.toString();
    const requestsExcel = await CollectOrderService.getCollectOrders(`?${queryString}`, currentPageCollectOrders, 0, true);
  
    exportToExcelCollectOrders(requestsExcel.collectOrders)
  }



  return (
    <div className="flex w-full h-full justify-center items-center py-4 px-4 bg-gray-200">

      <div className="flex flex-col w-full h-full rounded-xl py-8 px-6 gap-12 bg-white">

      <div className="flex flex-col w-full h-full gap-4 border border-gray-800 border-opacity-40 rounded-xl p-2">

          {/* <div className="flex">

            <div className="w-full text-md font-semibold">
                Consulta Gerencial de Coletas
            </div>
            
            <button onClick={()=>exportToExcel(collecOrdersList.collectOrders)} className="flex justify-center items-center bg-green-600 px-2 py-1 rounded-lg text-white gap-2">
              <FaFileExcel />
              <div>Exportar</div>
            </button>
          </div> */}

          <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-2">
            <div className="flex items-center gap-1 w-full">
              <HiOutlineDocumentReport size={20} />
              <p>Consulta Gerencial de Coletas</p>
            </div>

            <button onClick={() => handleExportToExcel(collecOrdersList.collectOrders)} className="flex justify-center items-center bg-green-600 px-2 py-1 rounded-lg text-white gap-2">
              <FaFileExcel />
              <div>Exportar</div>
            </button>
          </div>

          <div className="flex flex-col justify-between w-full h-full">

            <div className="flex flex-col gap-4 max-h-full">

              {/* FILTROS */}
              <div className="flex flex-wrap gap-3 items-end text-[10px]">

                <div className="flex flex-col w-fit">
                  <label className="text-[10px] font-semibold ms-2">UF</label>
                  <select
                    defaultValue=""
                    value={searchUF}
                    onChange={(e) => setSearchUF(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled></option>
                    {Estados.map((uf, index) => (
                      <option key={index} value={uf.sigla}>{uf.sigla}</option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col w-40">
                  <label className="text-[10px] font-semibold ms-2">Empresa</label>
                  <select
                    defaultValue=""
                    value={searchEmpresa}
                    onChange={(e) => setSearchEmpresa(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled>Selecione</option>
                    {companiesList.map((company) => (
                      <option key={company._id} value={company.name}>
                        {company.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">Status</label>
                  <select
                    defaultValue=""
                    value={searchStatus}
                    onChange={(e) => setSearchStatus(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled>Selecione</option>
                    {Object.keys(StatusCollectOrders).map((key, index) => (
                      <option key={index} value={key}>{StatusCollectOrders[key].descricao}</option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">ID Coleta</label>
                  <input
                    type="text"
                    placeholder="ID Coleta"
                    value={searchIdColeta}
                    onChange={(e) => setSearchIdColeta(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">Solicitação Ref</label>
                  <input
                    type="text"
                    placeholder="ID Solicitação"
                    value={searchIdRequest}
                    onChange={(e) => setSearchIdRequest(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col w-40">
                  <label className="text-[10px] font-semibold ms-2">Tipo Coleta</label>
                  <select
                    defaultValue=""
                    value={searchTipoColeta}
                    onChange={(e) => setSearchTipoColeta(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled>Selecione</option>
                    {TiposColeta.map((tipo, index) => (
                      <option key={index} value={tipo.cod}>
                        {tipo.cod} - {tipo.descricao}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex gap-2 rounded-lg bg-zinc-200 px-2">
                  <div className="flex flex-col min-w-32">
                    <label className="text-[10px] font-semibold ms-2">Aberto de</label>
                    <input
                      type="date"
                      placeholder="Start Date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  <div className="flex flex-col min-w-32">
                    <label className="text-[10px] font-semibold ms-2">até</label>
                    <input
                      type="date"
                      placeholder="End Date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                </div>

                <div className="flex flex-col w-40">
                  <label className="text-[10px] font-semibold ms-2">Gmo</label>
                  <select
                    defaultValue=""
                    value={searchGmo}
                    onChange={(e) => setSearchGmo(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled>Selecione</option>
                    {gmoList.map((gmo) => (
                      <option key={gmo._id} value={gmo._id}>
                        {gmo.cidade} - {gmo.endereco}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">Cód Sap</label>
                  <input
                    type="text"
                    placeholder="Cód Sap"
                    value={searchCodSap}
                    onChange={(e) => setSearchCodSap(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">Equipamento</label>
                  <input
                    type="text"
                    placeholder="Nome equipamento"
                    value={searchEquipamento}
                    onChange={(e) => setSearchEquipamento(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>

                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">Cód Barras</label>
                  <input
                    type="text"
                    placeholder="Cód. barras"
                    value={searchCodigo}
                    onChange={(e) => setSearchCodigo(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>

                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">Serial</label>
                  <input
                    type="text"
                    placeholder="Nº de série"
                    value={searchSerial}
                    onChange={(e) => setSearchSerial(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>


                <div className="flex gap-2 items-end">
                  {/* <button onClick={handleSubmit} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                  Buscar
                </button> */}
                  <button onClick={clearFilters} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                    Limpar Filtros
                  </button>
                  <button onClick={handleSearch} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                    Buscar
                  </button>
                </div>

              </div>

              {/* TABELA */}
              <div className="w-full mt-4">
                <div className="flex gap-1 ms-2 text-xs">Total: <div className="font-bold">{collecOrdersList.totalCollectOrders} registros</div></div>
                <div className="overflow-x-auto">
                  <table className="min-w-full bg-white rounded-lg text-[10px]">
                    <thead className="bg-gray-200">
                      <tr>
                        {/* <th className="py-2 px-4 border-b rounded-tl-lg">UF</th> */}
                        <th className="py-2 px-4 border-b">UF</th>
                        {/* <th className="py-2 px-4 border-b">Empresa</th> */}
                        <th className="py-2 px-4 border-b">Status</th>
                        <th className="py-2 px-4 border-b">ID Coleta</th>
                        <th className="py-2 px-4 border-b">Solicitação Ref</th>
                        <th className="py-2 px-4 border-b">Empresa</th>
                        <th className="py-2 px-4 border-b">Tipo Coleta</th>
                        <th className="py-2 px-4 border-b">Criado em</th>
                        <th className="py-2 px-4 border-b">GMO</th>
                        <th className="py-2 px-4 border-b">Cod Sap</th>
                        {/* <th className="py-2 px-4 border-b">Equipamento</th> */}
                        <th className="py-2 px-4 border-b">Fabricante</th>
                        <th className="py-2 px-4 border-b">Qtdade Coleta</th>
                        <th className="py-2 px-4 border-b">Qtdade Aceita</th>
                        <th className="py-2 px-4 border-b">Qtdade Rejeitada</th>
                        <th className="py-2 px-4 border-b">Contato</th>
                        <th className="py-2 px-4 border-b">Telefone</th>
                        <th className="py-2 px-4 border-b">SLA Coleta</th>
                        <th className="py-2 px-4 border-b">Coletado em</th>
                        <th className="py-2 px-4 border-b rounded-tr-lg">Recebido Por</th>
                      </tr>
                    </thead>
                    <tbody>
                      {collecOrdersList.collectOrders?.map((collectOrder, index) => (
                        <tr key={index} className={"border-b hover:bg-gray-100"}>
                          {/* <td className="py-1 px-4">{collectOrder.uf}</td> */}
                          <td className="py-1 px-4 cursor-pointer"><div className="flex justify-center items-center gap-2">{collectOrder.uf}</div></td>
                          {/* <td className="py-1 px-4 cursor-pointer"><div className="flex justify-center items-center gap-2">{collectOrder.empresaSolicitante}</div></td> */}
                          <td className="py-1 px-4">
                            <div className="flex justify-start items-center gap-2">
                              <FaCircle
                                className="flex-none"
                                color={StatusCollectOrders[collectOrder.status]?.cor || "#000000"}
                                size={15}
                              />
                              {collectOrder.status}
                            </div>
                          </td>
                          <td className="py-1 px-4 cursor-pointer"><div className="flex justify-center items-center gap-2 whitespace-nowrap cursor-pointer underline font-bold" onClick={()=>handleCollectOrderDetailsModal(collectOrder?._id)}>{collectOrder.idCollectOrder}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.idRequest ? collectOrder?.idRequest : 'AVULSO'}</div></td>
                          <td className="py-1 px-4">{collectOrder.empresaTecnico?.socialName}</td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2 min-w-20">{getDescricaoByCod(collectOrder?.tipoColeta)}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{format(parseISO(collectOrder?.createdAt), 'dd/MM/yy HH:mm')}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{collectOrder?.gmo?.cidade}</div></td>
                          <td className="py-1 px-4 whitespace-nowrap"><div className="flex justify-center items-center gap-2">{collectOrder?.codEquipamentoColeta}</div></td>
                          {/* <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{collectOrder?.nomeEquipamentoColeta}</div></td> */}
                          <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{collectOrder?.fabricanteEquipamentoColeta}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.qtdColeta}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.qtdAceita}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.qtdRejeitada}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.nomeSolicitante}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.contatoSolicitante}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.slaCollectDate ? format(parseISO(collectOrder.slaCollectDate), 'dd/MM/yy HH:mm') : ""}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.dataHoraColeta ? format(parseISO(collectOrder.dataHoraColeta), 'dd/MM/yy HH:mm') : ""}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.recebidoPor?.name}</div></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

            </div>

            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 gap-2 text-xs">
              <button
                className={`px-2 py-1 rounded-md ${currentPageCollectOrders === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChange(currentPageCollectOrders - 1)}
                disabled={currentPageCollectOrders === 1}
              >
                {'<'}
              </button>
              {[...Array(collecOrdersList.totalPages)].map((_, index) => (
                <button
                  key={index}
                  className={`px-2 py-1 rounded-md ${currentPageCollectOrders === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
              <button
                className={`px-2 py-1 rounded-md ${currentPageCollectOrders === collecOrdersList.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChange(currentPageCollectOrders + 1)}
                disabled={currentPageCollectOrders === collecOrdersList.totalPages}
              >
                {'>'}
              </button>
            </div>

          </div>

        </div>

      </div>

      {collectOrderOnDetailsModal &&
        <div className="absolute">
          <CollectOrderDetailsModal
            isModalOpen={collectOrderDetailsModal}
            setModalOpen={() => {
              setCollectOrderDetailsModal(!collectOrderDetailsModal);
            }}
            collectOrderId={collectOrderOnDetailsModal}
          // setTicketCb={setTicket}
          ></CollectOrderDetailsModal>
        </div>
      }

    </div>
  )
}
